import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';
import 'react-toastify/dist/ReactToastify.css';

class ManagementService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.MANAGEMENT_URL = '/api/management';
        this.EPIC = '/api/epic';
        this.STORY = '/api/story';
        this.TASK = '/api/task';

        this.GET_BY_ID = '/{id}';
        this.GET_SIMPLE_BY_ID = '/simple/{id}';
        this.GET_DELETED_BY_ID = '/deleted/{id}';

        this.GET_LIST_IN_TEAM_IN_ORG = '/list/team/{teamId}/org/{orgId}';
        this.GET_LIST_IN_PROJECT = '/list/project/{projectId}';
        this.GET_SIMPLE_LIST_IN_PROJECT = '/simple/list/project/{projectId}';
        this.GET_LIST_IN_PARENT = '/list/parent/{parentType}/{parentId}';
        this.GET_SIMPLE_LIST_IN_PARENT = '/simple/list/parent/{parentType}/{parentId}';
        this.GET_SIMPLE_LIST_IN_LIST = '/simple/list/list/{listId}';
        this.GET_CHILDREN_FOR_PARENT_IN_GROUP_ITEM = '/list/type/{type}/{parentType}/{parentId}/listId/{listId}';
        this.GET_SIMPLE_LIST_IN_PARENT_IN_LIST = '/simple/list/parent/{parentType}/{parentId}/list/{listId}';
        this.GET_TASK_LIST_BY_PROJECT_AND_CONNECTION = '/list/project-connection';
        this.GET_TASK_LIST_BY_PROJECT_AND_CONNECTION_AND_ASSIGNEE = '/list/project-connection/assignee';
        this.GET_LIST_BY_ASSIGNEE_AND_CONNECTION_AND_RELEASE = '/list/assignee-connection-release';
        this.GET_LIST_BY_USER = '/list/user/{assigneeUserId}';
        this.GET_LIST_BY_USER_IN_PROJECT_LIST = '/list/project/list/user/{assigneeUserId}';
        this.GET_RELATED_LIST_BY_USER = '/list/related/user/{assigneeUserId}';
        this.GET_LIST_BY_USER_IN_PERIOD = '/list/user/{assigneeUserId}/from/{startTime}/to/{endTime}';

        this.GET_LIST_BY_STATUS_IN_PROJECT = '/list/status/{status}/project/{projectId}';
        this.GET_LIST_BY_STATUS_IN_PARENT = '/list/status/{status}/{parentType}/{parentId}';
        this.GET_DEFAULT_WATCHER_LIST_BY_PARENT = '/list/default/watcher/{parentType}/{parentId}';
        this.SEARCH_ISSUES_BY_KEYWORD_FOR_USER = '/search/issues/user/{userId}/keyword/{keyword}';
        this.SEARCH_ISSUES_BY_KEYWORD_IN_PROJECT = '/search/issues/project/{projectId}/keyword/{keyword}';
        this.RECOMMENDATION_ISSUE_LIST_FOR_LINK_IN_PROJECT = '/search/issues/recommendation/project/{projectId}/keyword/{keyword}';
        this.COUNT_OF_SEARCH_ISSUES_BY_KEYWORD_FOR_USER = '/search/count/issues/user/{userId}/keyword/{keyword}';
        this.GET_ORGANIZED_STRUCTURE = '/list/organized/project/{projectId}/listId/{listId}';
        this.GET_ORGANIZED_STRUCTURE_BY_RELEASE = '/list/organized/project/{projectId}/listId/{listId}/releaseId/{releaseId}';
        this.GET_CHILDREN_FOR_PARENT_IN_LIST_BY_RELEASE = '/list/{parentType}/{parentId}/listId/{listId}/releaseId/{releaseId}';
        this.GET_CHILDREN_FOR_PARENT_IN_LIST_BY_RELEASE_AND_ASSIGNEE = '/list/{parentType}/{parentId}/listId/{listId}/releaseId/{releaseId}/assignee/{assigneeUserId}';
        this.GET_CHILDREN_FOR_PROJECT_IN_LIST_BY_RELEASE_AND_STATUS = '/list/project/{projectId}/listId/{listId}/releaseId/{releaseId}/status/{status}';
        this.GET_ISSUES_FOR_ASSIGNEE_IN_PROJECT_IN_LIST_BY_RELEASE = '/list/assignee/{assigneeUserId}/project/{projectId}/listId/{listId}/releaseId/{releaseId}';
        this.GET_PM_ANALYSIS = '/analyze/project/{projectId}';
        this.GET_PM_ANALYSIS_FOR_LIST = '/analyze/project/{projectId}/list/{listId}';
        this.GET_PM_ANALYSIS_FOR_RELEASE = '/analyze/project/{projectId}/release/{releaseId}';
        this.GET_PM_ANALYSIS_FOR_ORG = '/list/analyze/org/{orgId}/user/{userId}';
        this.GET_PM_ANALYSIS_FOR_PROJECT_LIST = '/list/analyze/project';
        this.GET_PM_ANALYSIS_FOR_USER_LIST = '/list/analyze/user';
        this.GET_PM_ANALYSIS_COUNT_FOR_USER= '/count/analyze/user/{assigneeUserId}';
        this.GET_EXCEL_VALUE = '/list/issues/excel'

        this.UPDATE_TITLE = '/update/title';
        this.UPDATE_SETTINGS = '/update/settings';
        this.UPDATE_PRIORITY = '/update/priority';
        this.UPDATE_DUE_DATE = '/update/due';
        this.UPDATE_START_DATE = '/update/start';
        this.UPDATE_STATUS = '/update/status';
        this.UPDATE_STATUS_UPDATE = '/update/status-update';
        this.UPDATE_ASSIGNEE = '/update/assignee';
        this.UPDATE_COMMENT = '/update/comment';
        this.UPDATE_PINNED_COMMENT = '/update/pin-comment';
        this.UPDATE_GROUP_ITEM = '/update/group-item';
        this.UPDATE_RELEASE = '/update/release';
        this.UPDATE_LIST = '/update/list';
        this.REOPEN = '/reopen';
        this.MIGRATE = '/migrate';

        this.UPDATE_GROUP_ITEM_STATUS_BY_ADMIN = '/update/group-item/status';
        this.UPDATE_GROUP_ITEM_STATUS_BY_TASK_ADMIN = '/update/group-item/task/status';
        this.KAIZIQ_MANAGE = '/api/kaiziq-manage';

        this.GET_ISSUE_LIST_FILTERED = '/list/issues';
        this.COUNT_ISSUE_LIST_FILTERED = '/count/issues';
        this.COUNT_ISSUE_LIST_FILTERED_FOR_EXPORT = '/count/export/issues';
        this.GET_PROJECT_FILES = '/list/project/files/{tag}';
        this.GET_PROJECT_FILES_FOLDERS = '/list/project/files/folders/{projectId}';

        this.ADD_WATCHER = '/watcher/add';
        this.DELETE_WATCHER = '/watcher/delete';

    }

    async getIssueListFiltered(filter) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_MANAGE + this.GET_ISSUE_LIST_FILTERED;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filter)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async countIssueListFiltered(filter) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_MANAGE + this.COUNT_ISSUE_LIST_FILTERED;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filter)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async countIssueListFilteredForExports(filter) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_MANAGE + this.COUNT_ISSUE_LIST_FILTERED_FOR_EXPORT;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filter)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    /**
     * REST Protocols for Epics.
     *
     * GET Requests:
     *     1) getEpic - GET By ID
     *     2) getDeletedEpic - GET By ID
     *     3) getEpicListInProject - GET LIST By PROJECT -> TEAM -> ORG
     *     4) getEpicListForUser - GET LIST By USER -> ORG
     *     5) getEpicListForUserInPeriod GET LIST By USER -> START-TIME <-> END-TIME
     *     6) getEpicListWithStatus - GET LIST BY STATUS -> PROJECT -> TEAM -> ORG
     *
     * POST Requests:
     *     1) createEpic - CREATE Epic
     *
     * PUT Requests:
     *     1) updateEpic - UPDATE Epic
     *
     * DELETE Requests:
     *     1) deleteEpic - DELETE Epic
     */

    async getEpic(id) {
        let url = window.location.origin + this.EPIC + this.GET_BY_ID;
        url = url
            .replace('{id}', id);
        try {
            const epicDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return epicDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleEpic(id) {
        let url = window.location.origin + this.EPIC + this.GET_SIMPLE_BY_ID;
        url = url
            .replace('{id}', id);
        try {
            const epicDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return epicDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getDeletedEpic(id) {
        let url = window.location.origin + this.EPIC + this.GET_DELETED_BY_ID;
        url = url
            .replace('{id}', id);
        try {
            const epicDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return epicDataRet;
        } catch (err) {
            console.log(err);
        }
    }


    async getEpicListInProject(projectId) {
        let url = window.location.origin + this.EPIC + this.GET_LIST_IN_PROJECT;
        url = url
            .replace('{projectId}', projectId);
        try {
            const epicDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return epicDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleEpicListInProject(projectId) {
        let url = window.location.origin + this.EPIC + this.GET_SIMPLE_LIST_IN_PROJECT;
        url = url
            .replace('{projectId}', projectId);
        try {
            const epicDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return epicDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleEpicListInList(listId) {
        let url = window.location.origin + this.EPIC + this.GET_SIMPLE_LIST_IN_LIST;
        url = url
            .replace('{listId}', listId);
        try {
            const epicDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return epicDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getEpicListForUser(assigneeUserId) {
        let url = window.location.origin + this.EPIC + this.GET_LIST_BY_USER;
        url = url
            .replace('{assigneeUserId}', assigneeUserId);
        try {
            const epicDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return epicDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getEpicListForUserInPeriod(assigneeUserId, startTime, endTime) {
        let url = window.location.origin + this.EPIC + this.GET_LIST_BY_USER_IN_PERIOD;
        url = url
            .replace('{assigneeUserId}', assigneeUserId)
            .replace('{startTime}', startTime)
            .replace('{endTime}', endTime);
        try {
            const epics = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return epics;
        } catch (err) {
            console.log(err);
        }
    }

    async getEpicListWithStatus(status, projectId) {
        let url = window.location.origin + this.EPIC + this.GET_LIST_BY_STATUS_IN_PROJECT;
        url = url
            .replace('{status}', status)
            .replace('{projectId}', projectId);
        try {
            const epicDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return epicDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getAssigneeAndSubAssigneeIdListForTask(parentType, parentId) {
        let url = window.location.origin + this.TASK + this.GET_DEFAULT_WATCHER_LIST_BY_PARENT;
        url = url
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId);
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getEpicListForUserInProjectList(assigneeUserId, projectIdList) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.GET_LIST_BY_USER_IN_PROJECT_LIST;
        url = url
            .replace('{assigneeUserId}', assigneeUserId);
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(projectIdList)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async createEpic(epic) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(epic)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateEpicTitle(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.UPDATE_TITLE;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err);
        }
    }

    async updateEpicSettings(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.UPDATE_SETTINGS;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err);
        }
    }

    async updateEpic(epic) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(epic)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateEpicPriority(id, priority) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.UPDATE_PRIORITY;
        let body = {
            id: id,
            priority: priority
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateEpicDueDate(id, dueDateTimeStamp) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.UPDATE_DUE_DATE;
        let body = {
            id: id,
            dueDateTimeStamp: dueDateTimeStamp
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateEpicStartDate(id, startDateTimeStamp) {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.EPIC + this.UPDATE_START_DATE;
            let body = {
                id: id,
                startDateTimeStamp: startDateTimeStamp
            }
            try{
                return this.fetch(url, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(body)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            } catch(err) {
                console.log(err);
            }
        }

    async updateEpicStatus(id, status) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.UPDATE_STATUS;
        let body = {
            id: id,
            status: status
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateEpicStatusUpdate(id, statusUpdate) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.UPDATE_STATUS_UPDATE;
        let body = {
            id: id,
            statusUpdate: statusUpdate
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateEpicReleaseId(id, releaseId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.UPDATE_RELEASE;
        let body = {
            id: id,
            releaseId: releaseId
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateEpicAssignee(id, assigneeUserId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.UPDATE_ASSIGNEE;
        let body = {
            id: id,
            assigneeUserId: assigneeUserId
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateEpicComment(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.UPDATE_COMMENT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateEpicPinnedComment(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.UPDATE_PINNED_COMMENT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async reopenEpic(id) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.REOPEN;
        let updateMap = {
            'id': id
        };
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async migrateEpic(id, projectId, kaiziqManageConnectionId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.MIGRATE;
        let updateMap = {
            'id': id,
            'projectId': projectId,
            'kaiziqManageConnectionId': kaiziqManageConnectionId
        };
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async addEpicWatcher(watcher) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.ADD_WATCHER;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(watcher)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteEpicWatcher(watcher) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC + this.DELETE_WATCHER;
        try{
            return this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(watcher)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteEpic(id){
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.EPIC;
        let deleteEpicData = {
            'id': id
        };
        try {
            const epicDataRet = await this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(deleteEpicData)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return epicDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    /**
     * REST Protocols for Stories.
     *
     * GET Requests:
     *     1) getStory - GET By ID
     *     2) getDeletedStory - GET By ID
     *     3) getStoryListInParent - GET LIST By PARENT -> TEAM -> ORG
     *     4 getStoryListForUser - GET LIST By USER -> ORG
     *     5) getStoryListForUserInPeriod GET LIST By USER -> START-TIME <-> END-TIME
     *     6) getStoryListWithStatus - GET LIST BY STATUS -> PARENT -> TEAM -> ORG
     *
     * POST Requests:
     *     1) createStory - CREATE Story
     *
     * PUT Requests:
     *     1) updateStory - UPDATE Story
     *
     * DELETE Requests:
     *     1) deleteStory - DELETE Story
     */

    async getStory(id) {
        let url = window.location.origin + this.STORY + this.GET_BY_ID;
        url = url
            .replace('{id}', id);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleStory(id) {
        let url = window.location.origin + this.STORY + this.GET_SIMPLE_BY_ID;
        url = url
            .replace('{id}', id);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getDeletedStory(id) {
        let url = window.location.origin + this.STORY + this.GET_DELETED_BY_ID;
        url = url
            .replace('{id}', id);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getStoryListInProject(projectId) {
        let url = window.location.origin + this.STORY + this.GET_LIST_IN_PROJECT;
        url = url
            .replace('{projectId}', projectId);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleStoryListInProject(projectId) {
        let url = window.location.origin + this.STORY + this.GET_SIMPLE_LIST_IN_PROJECT;
        url = url
            .replace('{projectId}', projectId);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getStoryListInParent(parentType, parentId) {
        let url = window.location.origin + this.STORY + this.GET_LIST_IN_PARENT;
        url = url
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleStoryListInParent(parentType, parentId) {
        let url = window.location.origin + this.STORY + this.GET_SIMPLE_LIST_IN_PARENT;
        url = url
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleStoryListInParentInList(parentType, parentId, listId) {
        let url = window.location.origin + this.STORY + this.GET_SIMPLE_LIST_IN_PARENT_IN_LIST;
        url = url
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId)
            .replace('{listId}', listId);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getStoryListForUser(assigneeUserId) {
        let url = window.location.origin + this.STORY + this.GET_LIST_BY_USER;
        url = url
            .replace('{assigneeUserId}', assigneeUserId);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getStoryListForUserInPeriod(assigneeUserId, startTime, endTime) {
        let url = window.location.origin + this.STORY + this.GET_LIST_BY_USER_IN_PERIOD
        url = url
            .replace('{assigneeUserId}', assigneeUserId)
            .replace('{startTime}', startTime)
            .replace('{endTime}', endTime);
        try {
            const stories = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return stories;
        } catch (err) {
            console.log(err);
        }
    }

    async getStoryListWithStatus(status, parentType, parentId) {
        let url = window.location.origin + this.STORY + this.GET_LIST_BY_STATUS_IN_PARENT;
        url = url
            .replace('{status}', status)
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getStoryListWithStatusInProject(status, projectId) {
        let url = window.location.origin + this.STORY + this.GET_LIST_BY_STATUS_IN_PROJECT;
        url = url
            .replace('{status}', status)
            .replace('{projectId}', projectId);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getAssigneeAndSubAssigneeIdListForStory(parentType, parentId) {
        let url = window.location.origin + this.TASK + this.GET_DEFAULT_WATCHER_LIST_BY_PARENT;
        url = url
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId);
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getStoryListForUserInProjectList(assigneeUserId, projectIdList) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.GET_LIST_BY_USER_IN_PROJECT_LIST;
        url = url
            .replace('{assigneeUserId}', assigneeUserId);
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(projectIdList)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async createStory(story) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY;
        try {
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(story)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateStoryTitle(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.UPDATE_TITLE;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err);
        }
    }

    async updateStorySettings(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.UPDATE_SETTINGS;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err);
        }
    }

    async updateStory(story) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(story)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateStoryPriority(id, priority) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.UPDATE_PRIORITY;
        let body = {
            id: id,
            priority: priority
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateStoryDueDate(id, dueDateTimeStamp) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.UPDATE_DUE_DATE;
        let body = {
            id: id,
            dueDateTimeStamp: dueDateTimeStamp
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateStoryStartDate(id, startDateTimeStamp) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.UPDATE_START_DATE;
        let body = {
            id: id,
            startDateTimeStamp: startDateTimeStamp
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateStoryStatus(id, status) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.UPDATE_STATUS;
        let body = {
            id: id,
            status: status
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateStoryStatusUpdate(id, statusUpdate) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.UPDATE_STATUS_UPDATE;
        let body = {
            id: id,
            statusUpdate: statusUpdate
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateStoryAssignee(id, assigneeUserId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.UPDATE_ASSIGNEE;
        let body = {
            id: id,
            assigneeUserId: assigneeUserId
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }


    async updateStoryComment(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.UPDATE_COMMENT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateStoryPinnedComment(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.UPDATE_PINNED_COMMENT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateStoryReleaseId(id, releaseId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.UPDATE_RELEASE;
        let body = {
            id: id,
            releaseId: releaseId
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async reopenStory(id) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.REOPEN;
        let updateMap = {
            'id': id
        };
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async migrateStory(id, projectId, kaiziqManageConnectionId, parentType, parentId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.MIGRATE;
        let updateMap = {
            'id': id,
            'projectId': projectId,
            'kaiziqManageConnectionId': kaiziqManageConnectionId,
            'parentType': parentType,
            'parentId': parentId
        };
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async addStoryWatcher(watcher) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.ADD_WATCHER;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(watcher)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteStoryWatcher(watcher) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY + this.DELETE_WATCHER;
        try{
            return this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(watcher)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteStory(id) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.STORY;
        let deleteStoryData = {
            'id': id
        };
        try {
            const storyDataRet = await this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(deleteStoryData)
            }).then((data) => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return storyDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    /**
     * REST Protocols for Tasks.
     *
     * GET Requests:
     *     1) getTask - GET By ID
     *     2) getDeletedTask - GET By ID
     *     3) getTaskListInParent - GET LIST By PARENT -> TEAM -> ORG
     *     4) getTaskListInProject - GET LIST By PROJECT -> TEAM -> ORG
     *     5) getTaskListForUser - GET LIST By USER -> ORG
     *     6) getTaskListForUserInPeriod GET LIST By USER -> START-TIME <-> END-TIME
     *     7) getTaskListWithStatus - GET LIST BY STATUS -> PARENT -> TEAM -> ORG
     *
     * POST Requests:
     *     1) createTask - CREATE Task
     *
     * PUT Requests:
     *     1) updateTask - UPDATE Task
     *
     * DELETE Requests:
     *     1) deleteTask - DELETE Task
     */

    async getTask(id) {
        let url = window.location.origin + this.TASK + this.GET_BY_ID;
        url = url
            .replace('{id}', id);
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleTask(id) {
        let url = window.location.origin + this.TASK + this.GET_SIMPLE_BY_ID;
        url = url
            .replace('{id}', id);
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getDeletedTask(id) {
        let url = window.location.origin + this.TASK + this.GET_DELETED_BY_ID;
        url = url
            .replace('{id}', id);
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTaskListInParent(parentType, parentId) {
        let url = window.location.origin + this.TASK + this.GET_LIST_IN_PARENT;
        url = url
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId);
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleTaskListInParent(parentType, parentId) {
        let url = window.location.origin + this.TASK + this.GET_SIMPLE_LIST_IN_PROJECT;
        url = url
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId);
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTaskListInProject(projectId) {
        let url = window.location.origin + this.TASK + this.GET_LIST_IN_PROJECT;
        url = url
            .replace('{projectId}', projectId);
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleTaskListInProject(projectId) {
        let url = window.location.origin + this.TASK + this.GET_SIMPLE_LIST_IN_PROJECT;
        url = url
            .replace('{projectId}', projectId);
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTaskListForUser(assigneeUserId) {
        let url = window.location.origin + this.TASK + this.GET_LIST_BY_USER;
        url = url
            .replace('{assigneeUserId}', assigneeUserId);
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTaskListForUserInPeriod(assigneeUserId, startTime, endTime) {
        let url = window.location.origin + this.TASK + this.GET_LIST_BY_USER_IN_PERIOD;
        url = url
            .replace('{assigneeUserId}', assigneeUserId)
            .replace('{startTime}', startTime)
            .replace('{endTime}', endTime);
        try {
            const tasks = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return tasks;
        } catch (err) {
            console.log(err);
        }
    }

    async getTaskListWithStatus(status, parentType, parentId) {
        let url = window.location.origin + this.TASK + this.GET_LIST_BY_STATUS_IN_PARENT;
        url = url
            .replace('{status}', status)
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId);
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTaskListWithStatusInProject(status, projectId) {
        let url = window.location.origin + this.TASK + this.GET_LIST_BY_STATUS_IN_PROJECT;
        url = url
            .replace('{status}', status)
            .replace('{projectId}', projectId);
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTaskListForUserInProjectList(assigneeUserId, projectIdList) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.GET_LIST_BY_USER_IN_PROJECT_LIST;
        url = url
            .replace('{assigneeUserId}', assigneeUserId);
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(projectIdList)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async createTask(task) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK;
        try {
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(task)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err);
        }
    }

    async updateTaskTitle(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_TITLE;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err);
        }
    }

    async updateTaskSettings(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_SETTINGS;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err);
        }
    }

    async updateTask(task) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(task)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err);
        }
    }

    async updateTaskPriority(id, priority) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_PRIORITY;
        let body = {
            id: id,
            priority: priority
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTaskDueDate(id, dueDateTimeStamp) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_DUE_DATE;
        let body = {
            id: id,
            dueDateTimeStamp: dueDateTimeStamp
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTaskStartDate(id, startDateTimeStamp) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_START_DATE;
        let body = {
            id: id,
            startDateTimeStamp: startDateTimeStamp
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTaskStatus(id, status) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_STATUS;
        let body = {
            id: id,
            status: status
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTaskStatusUpdate(id, statusUpdate) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_STATUS_UPDATE;
        let body = {
            id: id,
            statusUpdate: statusUpdate
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTaskAssignee(id, assigneeUserId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_ASSIGNEE;
        let body = {
            id: id,
            assigneeUserId: assigneeUserId
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTaskComment(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_COMMENT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTaskPinnedComment(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_PINNED_COMMENT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateGroupItem(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_GROUP_ITEM;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err);
        }
    }

    async updateTaskReleaseId(id, releaseId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.UPDATE_RELEASE;
        let body = {
            id: id,
            releaseId: releaseId
        }
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async reopenTask(id) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.REOPEN;
        let updateTaskMap = {
            'id': id
        };
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateTaskMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async migrateTask(id, projectId, kaiziqManageConnectionId, parentType, parentId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.MIGRATE;
        let updateTaskMap = {
            'id': id,
            'projectId': projectId,
            'kaiziqManageConnectionId': kaiziqManageConnectionId,
            'parentType': parentType,
            'parentId': parentId
        };
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateTaskMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async addTaskWatcher(watcher) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.ADD_WATCHER;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(watcher)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteTaskWatcher(watcher) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.DELETE_WATCHER;
        try{
            return this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(watcher)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteTask(id) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK;
        let deleteTaskData = {
            'id': id
        };
        try {
            const taskDataRet = await this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(deleteTaskData)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return taskDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async searchIssuesByKeywordForUser(userId, keyword){
        let url = window.location.origin + this.MANAGEMENT_URL + this.SEARCH_ISSUES_BY_KEYWORD_FOR_USER;
        url = url
            .replace('{userId}', userId)
            .replace('{keyword}', keyword);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async searchIssuesByKeywordInProject(projectId, keyword){
        let url = window.location.origin + this.MANAGEMENT_URL + this.SEARCH_ISSUES_BY_KEYWORD_IN_PROJECT;
        url = url
            .replace('{projectId}', projectId)
            .replace('{keyword}', keyword);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async recommendationIssueByKeywordInProject(projectId, keyword){
        let url = window.location.origin + this.MANAGEMENT_URL + this.RECOMMENDATION_ISSUE_LIST_FOR_LINK_IN_PROJECT;
        url = url
            .replace('{projectId}', projectId)
            .replace('{keyword}', keyword);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async countForSearchIssuesByKeywordForUser(userId, keyword){
        let url = window.location.origin + this.MANAGEMENT_URL + this.COUNT_OF_SEARCH_ISSUES_BY_KEYWORD_FOR_USER;
        url = url
            .replace('{userId}', userId)
            .replace('{keyword}', keyword);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async getOrganizedStructureForProjectAndList(projectId, listId){
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_ORGANIZED_STRUCTURE;
        url = url
            .replace('{projectId}', projectId)
            .replace('{listId}', listId);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async getOrganizedStructureForProjectAndListAndRelease(projectId, listId, releaseId){
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_ORGANIZED_STRUCTURE_BY_RELEASE;
        url = url
            .replace('{projectId}', projectId)
            .replace('{listId}', listId)
            .replace('{releaseId}', releaseId);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async getChildrenForParentInRelease(parentType, parentId, listId, releaseId){
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_CHILDREN_FOR_PARENT_IN_LIST_BY_RELEASE;
        url = url
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId)
            .replace('{listId}', listId)
            .replace('{releaseId}', releaseId);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async getChildrenForParentInReleaseAndAssignee(parentType, parentId, listId, releaseId, assigneeUserId){
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_CHILDREN_FOR_PARENT_IN_LIST_BY_RELEASE_AND_ASSIGNEE;
        url = url
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId)
            .replace('{listId}', listId)
            .replace('{releaseId}', releaseId)
            .replace('{assigneeUserId}', assigneeUserId);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async getChildrenForProjectInReleaseAndStatus(projectId, listId, releaseId, status){
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_CHILDREN_FOR_PROJECT_IN_LIST_BY_RELEASE_AND_STATUS;
        url = url
            .replace('{projectId}', projectId)
            .replace('{listId}', listId)
            .replace('{releaseId}', releaseId)
            .replace('{status}', status);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async getIssuesForAssigneeInProjectInReleaseAndStatus(assigneeUserId, projectId, listId, releaseId){
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_ISSUES_FOR_ASSIGNEE_IN_PROJECT_IN_LIST_BY_RELEASE;
        url = url
            .replace('{assigneeUserId}', assigneeUserId)
            .replace('{projectId}', projectId)
            .replace('{listId}', listId)
            .replace('{releaseId}', releaseId);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async getPMAnalysis(projectId){
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_PM_ANALYSIS;
        url = url
            .replace('{projectId}', projectId);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async getPMAnalysisCountForUser(assigneeUserId){
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_PM_ANALYSIS_COUNT_FOR_USER;
        url = url
            .replace('{assigneeUserId}', assigneeUserId);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async getPMAnalysisForKaiziqManageConnection(projectId, listId){
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_PM_ANALYSIS_FOR_LIST;
        url = url
            .replace('{projectId}', projectId)
            .replace('{listId}', listId);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async getPMAnalysisForRelease(projectId, releaseId){
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_PM_ANALYSIS_FOR_RELEASE;
        url = url
            .replace('{projectId}', projectId)
            .replace('{releaseId}', releaseId);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async getPMAnalysisForOrganizationAndUser(orgId, userId){
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_PM_ANALYSIS_FOR_ORG;
        url = url
            .replace('{orgId}', orgId)
            .replace('{userId}', userId);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    // async getExcelData(filter) {
    //     try {
    //         const csrfToken = Cookies.get('XSRF-TOKEN');
    //         const url = window.location.origin + this.MANAGEMENT_URL + this.GET_EXCEL_VALUE;
    //
    //         const response = await this.fetch(url, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'X-XSRF-TOKEN': csrfToken,
    //             },
    //             body: JSON.stringify(filter),
    //         });
    //         const responseBody = await response.text();
    //         return responseBody;
    //     } catch (err) {
    //         console.error(err);
    //         throw err;
    //     }
    // }

    async getExcelData(filter) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_EXCEL_VALUE;

        try {
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(filter),
            }).then(response => response.text())
                .then(response => {
                    if (response.error !== undefined) {
                        if (response.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', response.uuid);
                        }
                    }
                    return response;
                });
        } catch (err) {
            console.error(err);
        }
    }


    async getPMAnalysisForProjectList(projectIdList) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_PM_ANALYSIS_FOR_PROJECT_LIST;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(projectIdList)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getPMAnalysisForUserList(userAnalysisObj) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_PM_ANALYSIS_FOR_USER_LIST;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(userAnalysisObj)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getListByProjectAndConnection(filterObj) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.GET_TASK_LIST_BY_PROJECT_AND_CONNECTION;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterObj)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getListByProjectAndConnectionAndAssignee(filterObj) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TASK + this.GET_TASK_LIST_BY_PROJECT_AND_CONNECTION_AND_ASSIGNEE;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterObj)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getProjectFiles(tag) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_PROJECT_FILES;
        url = url.replace('{tag}', tag)
        try{
            return this.fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getListByAssigneeAndConnectionAndRelease(agileObj) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_LIST_BY_ASSIGNEE_AND_CONNECTION_AND_RELEASE;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(agileObj)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getFilesFolders(projectId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_PROJECT_FILES_FOLDERS;
        url = url.replace('{projectId}', projectId)
        try{
            return this.fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateGroupItemStatusByAdmin(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.MANAGEMENT_URL + this.UPDATE_GROUP_ITEM_STATUS_BY_ADMIN;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateGroupItemStatusByTaskAndAdmin(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.MANAGEMENT_URL + this.UPDATE_GROUP_ITEM_STATUS_BY_TASK_ADMIN;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getChildrenForParentInGroupItem(type, parentType, parentId, listId) {
        let url = window.location.origin + this.MANAGEMENT_URL + this.GET_CHILDREN_FOR_PARENT_IN_GROUP_ITEM;
        url = url
            .replace('{type}', type)
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId)
            .replace('{listId}', listId);
        try {
            const agileItemData = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return agileItemData;
        } catch (err) {
            console.log(err);
        }
    }
}

export default ManagementService;
